import { render, staticRenderFns } from "./ModularFrontPageLayout.vue?vue&type=template&id=95e89df6"
import script from "./ModularFrontPageLayout.vue?vue&type=script&lang=js"
export * from "./ModularFrontPageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports